'use client';
import { BREAKPOINTS } from "../../constants/index.js";
export const getResponsiveClasses = (prefix, value) => {
  if (!value) {
    return [];
  }
  if (typeof value !== 'object') {
    return [prefix(value)];
  }
  return BREAKPOINTS.reduce((classes, breakpoint) => {
    const breakpointValue = value[breakpoint];
    if (!breakpointValue) return classes;
    return [...classes, prefix(`${breakpoint}-${breakpointValue}`)];
  }, []);
};